import React from 'react';
import { render, hydrate } from 'react-dom';
import objectFitImages from 'object-fit-images';
import TagManager from 'react-gtm-module';

import polyfills from './polyfills';
import Root from './Root';
import store from './redux/store';

import { lsSetItem, lsGetItem } from './utils';
import { CURRENT_PAGE, STYLIST_SALONID } from './pages/SalonConsultationPage/localStorageKeys';

if (process.env.NODE_ENV === 'development' && polyfills.length > 0) {
  console.info('Using polyfills: ', polyfills);
}

// GTM設定
const tagManagerArgs = {
  gtmId: 'GTM-P5G2HJ3',
};
TagManager.initialize(tagManagerArgs);

// IE11 では object-fit が適用されないため、object-fit-images モジュールを使用
objectFitImages();

let load = true;
const salonId = lsGetItem(STYLIST_SALONID);
const path = window.location.pathname;
const locale = path.slice(1).split('/')[0];
let currentPage = lsGetItem(CURRENT_PAGE);
// Salon-Consultation対象ページ判定
if (
  RegExp('/salon-consultation/').test(currentPage) &&
  RegExp('/salon-consultation/').test(path) &&
  !(RegExp('/salon-consultation/sign-up').test(path) && !salonId) &&
  !(RegExp('/salon-consultation/login').test(path) && !salonId)
) {
  if (currentPage !== 'null' && currentPage !== null && path !== currentPage) {
    // Redirect先指定
    if (
      !RegExp('/salon-consultation/sublimic/home$').test(currentPage) &&
      !RegExp('/salon-consultation/setting$').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis/user-survey').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis/scalp-camera').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis/stylist-diagnosis').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis/quick-diagnosis').test(currentPage) &&
      !RegExp('/salon-consultation/sublimic/diagnosis/result/top').test(currentPage) &&
      !RegExp('/salon-consultation/customer/regist&').test(currentPage) &&
      !RegExp('/salon-consultation/customer/top').test(currentPage) &&
      !RegExp('/salon-consultation/customer/top&').test(currentPage)
    ) {
      currentPage = `/${locale}/salon-consultation/home`;
    }
    load = false;
    lsSetItem(CURRENT_PAGE, null);
    window.location.href = currentPage;
  }
}

if (load) {
  const rootElement = document.getElementById('root');
  if (rootElement.hasChildNodes()) {
    hydrate(<Root store={store} />, rootElement);
  } else {
    render(<Root store={store} />, rootElement);
  }
}



// WEBPACK FOOTER //
// ./src/index.js